export const BedExitsControllerFactory = ({
  bedExitsService,
}: {
  bedExitsService: IBedExitsService;
}) => {
  const getBedExitEventList: IGetBedExitEventList = async ({
    paging,
    reload,
    clinic_id,
    floor_ids,
  }) => {
    let payload: Parameters<typeof bedExitsService.getBedExitEventList>[0] = {
      clinic_id,
      floor_ids,
      ...paging,
      page: paging.page + 1,
    };

    if (reload) {
      payload = { ...payload, page: 1 };
    }
    const response = await bedExitsService.getBedExitEventList(payload);
    return response;
  };

  const getBedExitFacilityReport: IPostBedExitFacilityReport = async ({
    clinicId,
    floorIds,
    currentRange,
    previousRange,
  }) => {
    const payload: Parameters<
      typeof bedExitsService.getBedExitFacilityReportService
    >[0] = {
      clinic_id: clinicId,
      floor_ids: floorIds,
      current_range: {
        start_datetime: currentRange.startDatetime,
        end_datetime: currentRange.endDatetime,
      },
      previous_range: {
        start_datetime: previousRange.startDatetime,
        end_datetime: previousRange.endDatetime,
      },
    };

    const response = await bedExitsService.getBedExitFacilityReportService(
      payload
    );
    return response;
  };

  return {
    addBedExits: bedExitsService.addBedExits,
    updateBedExits: bedExitsService.updateBedExits,
    deleteBedExits: bedExitsService.deleteBedExits,
    getBedExitSettingsByUserPref: bedExitsService.getBedExitSettingsByUserPref,
    updateBedExitsTimes: bedExitsService.updateBedExitsTime,
    getBedExitEventList,
    updateNotificationFromPatientChart:
      bedExitsService.updateNotificationFromPatientChart,
    updateCombineBedExits: bedExitsService.updateCombineBedExitsService,
    updateNotificationFromPatientChartV2:
      bedExitsService.updateNotificationFromPatientChartV2,
    getBedExitFacilityReport,
    addBedExitsV3: bedExitsService.addBedExitsV3,
  };
};
